import { ContactSection } from '@/components/contact-section';
import { AppLayout } from '@/layouts/app/app-layout';

export default function Kontakt() {
  return (
    <AppLayout title="Kontakt">
      {/* The nav is fixed and overlaps the top of the page, so the section
          starts below it instead of underneath. */}
      <div className="pt-24">
        <ContactSection animateHeading={false} location="contact-page" />
      </div>
    </AppLayout>
  );
}
